import React from 'react';
import PropTypes from 'prop-types';
import { breakpoints, belowBreakpoint, getIsInProgress } from '../utils';
import styled, { css } from 'styled-components';
import { AVAILABILITY_STATUSES } from '../constants';
import _ from 'lodash';

const AvailabilityCaption =
  /** @type {import('styled-components').ThemedStyledFunction<'div', {isSessionPopover:boolean, shouldDisplayNone:boolean}>} */
  (styled.div)`
    min-width: 160px;

    ${belowBreakpoint(breakpoints.md)} {
      flex: 1;
    }

    ${(props) =>
      props.isSessionPopover &&
      css`
        text-align: end;
        margin-right: 0.5rem;
      `}

    ${(props) =>
      props.shouldDisplayNone &&
      css`
        visibility: hidden;
      `}
  `;

export const Availability = ({
  subEvent,
  shouldShowExactAvailability,
  isSessionPopover = false,
}) => {
  let caption;

  const { remainingAttendeeCapacity } = subEvent;
  if (_.isNil(remainingAttendeeCapacity)) {
    return (
      <AvailabilityCaption
        isSessionPopover={isSessionPopover}
        shouldDisplayNone={true}
      ></AvailabilityCaption>
    );
  }

  const isInProgress = getIsInProgress(subEvent);

  const isFull = remainingAttendeeCapacity === 0;

  if (isFull) {
    caption = `Fully Booked`;
  } else if (isInProgress) {
    caption = `In Progress`;
  } else if (shouldShowExactAvailability) {
    caption = `${remainingAttendeeCapacity} Space${remainingAttendeeCapacity === 1 ? '' : 's'}`;
  } else if (remainingAttendeeCapacity < 5) {
    caption = AVAILABILITY_STATUSES.LIMITED;
  } else if (remainingAttendeeCapacity > 0) {
    caption = AVAILABILITY_STATUSES.AVAILABLE;
  } else {
    caption = AVAILABILITY_STATUSES.NONE;
  }

  return <AvailabilityCaption isSessionPopover={isSessionPopover}>{caption}</AvailabilityCaption>;
};

Availability.propTypes = {
  subEvent: PropTypes.object,
  shouldShowExactAvailability: PropTypes.bool,
  isSessionPopover: PropTypes.bool,
};
